<template>
  <div>
    <label>Pick enhancers</label>

    <md-autocomplete
      ref="autocomplete"
      v-model="value"
      :md-options="$availableOptions"
      @md-selected="onSelected($event)"
    />

    <div>
      <md-chip
        v-for="enhancer in selectedEnhancers"
        :key="enhancer"
        class="md-primary"
        md-deletable
        @click="onRemoved(enhancer)"
      >
        {{ enhancer }}
      </md-chip>
    </div>
  </div>
</template>
<script>
  export default {
    name: "EnhancerPicker",
    props: {
      selectedEnhancers: {
        type: Array,
        required: true,
        default() {
          return [];
        }
      }
    },
    data() {
      return {
        options: [],
        loading: true,

        value: "",
      };
    },
    computed: {
      $availableOptions() {
        return this.options.filter(o => !this.$props.selectedEnhancers.includes(o));
      }
    },
    mounted() {
      this.fetchOptions();
    },
    methods: {
      fetchOptions() {
        this.loading = true;
        setTimeout(() => {
          this.options = ["enhancer1", "enhancer2", "enhancer3"];
          this.loading = false;
        }, 4000);
      },
      emitUpdate(newSelection) {
        this.$emit("update:selectedEnhancers", newSelection);
      },
      onSelected(newValue) {
        this.emitUpdate([...this.$props.selectedEnhancers, newValue]);
        this.value = "";
        this.$refs["autocomplete"].searchTerm = "";
      },
      onRemoved(removedValue) {
        this.emitUpdate(this.$props.selectedEnhancers.filter(s => s !== removedValue));
      }
    }
  };
</script>
